import { render } from "./ChipSelect.vue?vue&type=template&id=5a6e6d8d&scoped=true&ts=true"
import script from "./ChipSelect.vue?vue&type=script&lang=ts"
export * from "./ChipSelect.vue?vue&type=script&lang=ts"

import "./ChipSelect.vue?vue&type=style&index=0&id=5a6e6d8d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6e6d8d"]])

export default __exports__